<template>
  <div class="product-image-cell" :style="{ width: size + 'px', height: size + 'px' }">
    <img v-if="url" :src="url" :alt="alt" :title="fromProduct ? $t('offers.image.fromProduct') : ''" @click.stop="$emit('zoom', url)" />
    <div v-else-if="notFound" class="product-image-cell__placeholder">
      <md-icon>image</md-icon>
    </div>
  </div>
</template>

<script>
import axiosFactory from "@/services/axios.factory";

// Modulweiter Cache je Bildquelle (null = kein Bild), wie bei ProductImage; der Schluessel enthaelt den Dateinamen,
// ein neu hochgeladenes Angebotsbild wird dadurch ohne Cache-Leeren geladen.
const cache = new Map();

/** Angebotsbild; ohne eigenes Bild das Bild des ersten Produkts mit Bild (ImageProductId der Liste). */
export default {
  name: "OfferImage",
  props: {
    offerId: { type: Number, required: true },
    image: { type: String, default: null },
    productId: { type: Number, default: null },
    alt: { type: String, default: "" },
    size: { type: Number, default: 56 },
  },
  data() {
    return { url: null, notFound: false };
  },
  computed: {
    fromProduct() {
      return !this.image && !!this.productId;
    },
    source() {
      if (this.image) return { key: `o:${this.offerId}:${this.image}`, path: `/offers/${this.offerId}/image/content` };
      if (this.productId) return { key: `p:${this.productId}`, path: `/shipping_data/products/${this.productId}/image/content` };
      return null;
    },
  },
  watch: {
    source: {
      immediate: true,
      handler(source) {
        this.url = null;
        this.notFound = false;
        if (!source) {
          this.notFound = true;
          return;
        }
        if (cache.has(source.key)) {
          this.url = cache.get(source.key);
          this.notFound = this.url === null;
          return;
        }
        axiosFactory()
          .get(source.path, { responseType: "blob" })
          .then((res) => {
            const url = URL.createObjectURL(new Blob([res.data]));
            cache.set(source.key, url);
            if (this.source && this.source.key === source.key) this.url = url;
          })
          .catch((err) => {
            if (err && err.response && err.response.status === 404) cache.set(source.key, null);
            if (this.source && this.source.key === source.key) this.notFound = true;
          });
      },
    },
  },
};
</script>
<style scoped>
.product-image-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.product-image-cell img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  cursor: zoom-in;
  border-radius: 3px;
}
.product-image-cell__placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f2f2;
  border-radius: 3px;
}
.product-image-cell__placeholder .md-icon {
  color: #c5c5c5;
}
</style>
